export default __webpack_public_path__ + "static/borrow-page-blurred-3fcd80eda96b27faf7fef8cc3e9036e5.png";